export const heroSection = {
  appStoreButton: {
    include: true,
    url: "",
  },
  playStoreButton: {
    include: false,
    url: "",
  },
  headingText: "CALCURA+E!",
  descriptionText:
    "Calculate your expenses in any currency required with the latest change",
};

/*
DOCUMENTATION

--appStoreButton 
    This controls the Download on App Store button. Set include to true if you want to make it 
    visible. Set include to false if you do not want it to be visible. Add a url to your app's 
    location on the App Store if it is available.

--playStoreButton
    This controls the Get It On Google Play button. Set include to true if you want to make it 
    visible. Set include to false if you do not want it to be visible. Add a url to your app's 
    location on the App Store if it is available.

--headingText
    The primary heading. Set it to something short and descriptive about your app.

--descriptionText
    The primary description of your app. Make a short statment about your app.
    
    Images

    Change mockup.png to change the mockup image next to the heading and description text.

    Change logo.png to change the logo image in the navigation and footer.
*/
